import { styled as r, modifier as a, css as c } from "@lokalise/styled";
import { spacing as t, typography as e, value as o } from "../../../../utils/theme/index.js";
import { Button as i } from "../../../Button/Button.js";
const b = r.div`
	width: 100%;
	position: relative;
	margin: ${t(4)} 0;
`, s = r.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: space-evenly;
`, u = r.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
	justify-content: center;
	gap: ${t(2)};
	z-index: 1;
`, g = r(i)`
	border-radius: 50%;
	width: 30px;
	height: 30px;

	${e("body.caption.default")};
	border-color: ${o("color.border.default")};
	color: ${o("color.text.light.default")};
	background-color: ${o("color.background.surface.default")};

	${a(
  "selected",
  c`
			${e("body.caption.strong")};
			border-color: ${o("color.border.active")};
			color: ${o("color.text.active")};
			background-color: ${o("color.background.active")};
		`
)}

	&:hover:not([disabled]):not([aria-expanded='true']) {
		border-color: ${o("color.background.action.primary.hover")};
		background-color: ${o("color.background.action.primary.hover")};
		color: ${o("color.text.inverse")};
	}

	&:active:not([disabled]):not([aria-expanded='true']),
	&:focus:active:not([disabled]):not([aria-expanded='true']) {
		border-color: ${o("color.background.action.primary.hover")};
		background-color: ${o("color.background.action.primary.hover")};
		color: ${o("color.text.inverse")};
	}

	&:disabled {
		background-color: ${o("color.background.disabled")};
		color: ${o("color.text.disabled")};
		border-color: ${o("color.border.disabled")};
	}
`, p = r.div`
	text-align: center;
	width: 100%;
	${e("body.small.default")}
`, $ = r.div`
	width: 100%;
	height: 1px;
	background: ${o("color.border.light")};
	position: absolute;
	margin-top: 14px;
`;
export {
  $ as BackgroundLine,
  b as PageCounterContainer,
  p as PageLabel,
  u as PageLabelContainer,
  g as PageNumber,
  s as PagesContainer
};
//# sourceMappingURL=styles.js.map
